import React, { FC } from 'react';
import { Box } from '@mui/material';
import bankIdSeLogo from 'assets/eid-bankid-se.png';
import bankIdNoLogo from 'assets/eid-bankid-no.png';
import mitIdDkLogo from 'assets/eid-mitid-dk.png';
import ftnFiLogo from 'assets/eid-ftn-fi.png';
import { AuthMethod } from 'models/user';

/**
 * DD-3513 — the official mark for an e-ID, on its brand colour.
 *
 * The marks come from Idura's own SDK, which bundles them for integrators building
 * login buttons. They are white on transparent and no dark variant is published, so
 * they cannot sit directly on this dialog's white background — hence the brand-coloured
 * tile. auth-frontend puts them on a full-width brand button instead; the two apps
 * share no component library, so this file mirrors the one there.
 */

type EidBrand = {
    logo: string;
    background: string;
};

const EID_BRANDS: Partial<Record<AuthMethod, EidBrand>> = {
    [AuthMethod.BANKID_SE]: { logo: bankIdSeLogo, background: 'hsl(198.46 52.7% 29.02%)' },
    [AuthMethod.BANKID_NO]: { logo: bankIdNoLogo, background: 'hsl(280 60% 18.63%)' },
    [AuthMethod.MITID_DK]: { logo: mitIdDkLogo, background: 'hsl(214.96 100% 45.1%)' },
    // FTN spans every Finnish bank plus Mobiilivarmenne and has no brand colour of its
    // own — Idura gives it a neutral dark grey and so do we.
    [AuthMethod.FTN_FI]: { logo: ftnFiLogo, background: 'hsl(0 0% 20%)' },
};

type EidMarkProps = {
    method: AuthMethod;
    alt: string;
};

const EidMark: FC<EidMarkProps> = ({ method, alt }: EidMarkProps) => {
    const brand = EID_BRANDS[method];
    if (!brand) {
        return null;
    }

    return (
        <Box
            sx={{
                width: 108,
                height: 60,
                flexShrink: 0,
                marginRight: '20px',
                borderRadius: 1,
                backgroundColor: brand.background,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 1,
            }}
        >
            <img alt={alt} src={brand.logo} style={{ maxWidth: '100%', maxHeight: '100%' }} />
        </Box>
    );
};

export default EidMark;
